export default "__VITE_ASSET__1VZ7582u__"